module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABOklEQVRYhe2WwW2DQBBFKcElUII7sDuwOzAlpINQgjuADqADbwnpwL78P9JeNh2Qy640goWEeMFSwkhzAmYeoz9/N8u22EKFtXYPoCJ5WyIBVNba/Whzkt0aKSLHAQDJ1r/QkjyLyDF1qh4mBvA5SpcoPERHsosBjI9nA5jXpBCR91idxQFEpNBq76/c4gAkjQYAUK4KAKCc2vdZAH6cTc9Emu8ASb4FL+k/+zGALzLlZMWcyfwG4EzSAChFJPcf5ySvCmTwh8kApoooiLtzbrc6gHNuF2wbQBVpkovIxXvBITlAlg3U3gA4icglItqO5D34QdI1JFlPCNV4yIeum9wH/Kq23oAMyWsQrZ4WgI9wxP/9w+gZgJdfSMJ16eZVfUiZAE5qS8wA4OWXUgVRK1Wnznr0Wr7Fv40v1BPXGSr/GEEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no_pic.png
// module id = KXse
// module chunks = 1